import memoizeOne from "memoize-one";

/**
 * Check if the "srcdoc" iFrame attribute is supported. This is used for displaying raw emails.
 * @returns True if the attribute is supported.
 */
const isSourceDocumentSupported = memoizeOne(() => !!("srcdoc" in document.createElement("iframe")));

export default isSourceDocumentSupported;
